/* eslint-disable no-restricted-globals */
/* eslint-disable no-useless-concat */
import { Investor } from '../types/investorTypes';
import { OwnFunds } from '../types/masterTypes';

export function abbreviatedNumber(value: number): string {
  if (value >= 1_000_000 && value < 1_000_000_000) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return `${spaceSeparatedThousands(+(value / 1_000_000).toFixed(2))} mln`;
  }
  if (value >= 1_000_000_000) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return `${spaceSeparatedThousands(+(value / 1_000_000_000).toFixed(2))} bln`;
  }

  return value.toString();
}

export function spaceSeparatedThousands(value: number, noDecimals?: boolean, abbreviateNumber?: boolean): string {
  if (typeof value !== 'number' || Number.isNaN(value) || !isFinite(value)) {
    return '-';
  }

  if (value === 0) {
    return '0.00';
  }

  if (Math.abs(value) >= 1_000_000 && abbreviateNumber) {
    return abbreviatedNumber(Math.abs(value));
  }

  let fixedValue = value.toString();

  // If the value is less than 1 and has exponential notation.
  if (Math.abs(value) < 1 && Math.abs(value) > 0 && fixedValue.toLowerCase().includes('e')) {
    const exponent = Math.abs(Math.floor(Math.log10(Math.abs(value))));
    if (exponent === 7) {
      fixedValue = value.toFixed(exponent + 1);
    } else {
      fixedValue = value.toFixed(exponent);
    }
  } else if (!noDecimals) {
    const decimalPlaces = fixedValue.split('.')[1]?.length || 0;
    fixedValue = value.toFixed(decimalPlaces);
  }

  const [integerPart, decimalPart] = fixedValue.split('.');

  // Formatting the integer part using commas as thousand separators
  let formattedIntegerPart = integerPart;
  const rgx = /(\d)(?=(\d{3})+(?!\d))/g;
  formattedIntegerPart = formattedIntegerPart.replace(rgx, '$1,');

  if (formattedIntegerPart === '' || formattedIntegerPart === '-') {
    formattedIntegerPart = '0';
  }

  let formattedDecimalPart = '';
  if (!noDecimals && decimalPart) {
    formattedDecimalPart = `.${decimalPart}`;
  } else if (!noDecimals) {
    formattedDecimalPart = '.00';
  }

  return formattedIntegerPart + formattedDecimalPart;
}

export function formatInputValue(value: number | string): string {
  if (!value) return '';

  const stringValue = `${value}`;

  if (/e/i.test(stringValue)) {
    const numericValue = parseFloat(stringValue);
    if (isNaN(numericValue)) return '';
    return numericValue.toFixed(8);
  }

  return stringValue;
}

export function safeFormatValue(value: any, formatter?: (val: any) => string): string {
  if (value == null || value === '') {
    return '';
  }

  if (formatter) {
    return formatter(value);
  }

  return value.toString();
}

export function getEquityOverInvestments(investor: Investor | OwnFunds): number {
  if (!investor?.Investments) {
    return 0;
  }

  return Number((((investor.Equity - investor.Investments) / Math.abs(investor.Investments)) * 100).toFixed(2));
}

export const getSign = (value: number): string => {
  if (value > 0) {
    return '+';
  }
  if (value < 0) {
    return '-';
  }

  return '';
};
